import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";

import { createBrowserHistory } from "history";
import { useEffect } from "react";
import { loadUser } from "./actions/auth";

import Home from "./pages/Home";
import ConfirmYourSeat from "./pages/ConfirmYourSeat";
// import About from "./pages/about";
import Modules from "./pages/Modules";
import Contact from "./pages/Contact";
import Schedule from "./pages/Schedule";
import Location from "./pages/Location";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Team from "./pages/Team";
import ScienceOlympiad from "./pages/ScienceOlympiad";
import Hackathon from "./pages/Hackathon";
import ModulesSelect from "./pages/ModulesSelect";
import Email from "./pages/Email";
import HackathonStepTwo from "./pages/HackathonStepTwo";

var hist = createBrowserHistory();

const App = () => {
  useEffect(() => {
    store.dispatch(loadUser());
  }, []);
  return (
    <Provider store={store}>
      <Router history={hist}>
        <Routes>
          <Route path="/*">
            <Route index element={<Home />} />
            <Route path="team" element={<Team />} />
            <Route path="register" element={<ConfirmYourSeat />} />
            <Route
              path="register/science-olympiad/step-one"
              element={<ScienceOlympiad />}
            />
            <Route
              path="register/science-olympiad/step-two/:team/:id"
              element={<ModulesSelect />}
            />
            <Route path="register/hackathon/step-one" element={<Hackathon />} />
            <Route
              path="register/hackathon/step-two/:type"
              element={<HackathonStepTwo />}
            />
            <Route path="login" element={<Login />} />
            <Route path="modules" element={<Modules />} />
            <Route path="contact" element={<Contact />} />
            <Route path="location" element={<Location />} />
            <Route path="schedule" element={<Schedule />} />
            <Route path="emailSent" element={<Email />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </Router>
    </Provider>
  );
};

export default App;
